import { render, staticRenderFns } from "./adidData.vue?vue&type=template&id=f2de121e&scoped=true&"
import script from "./adidData.vue?vue&type=script&lang=js&"
export * from "./adidData.vue?vue&type=script&lang=js&"
import style0 from "./adidData.vue?vue&type=style&index=0&id=f2de121e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2de121e",
  null
  
)

export default component.exports